import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { Observable } from 'rxjs';
import { PlatformDetectionService } from './oauth2/platform-detection.service';

/**
 * Platform-aware authentication guard that:
 * - On web: Uses MsalGuard for Azure AD authentication
 * - On mobile: Skips guard (authentication handled by MobileOAuth2Service in app init)
 */
@Injectable({
  providedIn: 'root'
})
export class PlatformAwareAuthGuard {
  constructor(
    private msalGuard: MsalGuard,
    private platformDetection: PlatformDetectionService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    console.log('=== PlatformAwareAuthGuard.canActivate ===');
    console.log('Platform:', this.platformDetection.getPlatform());
    console.log('isNative:', this.platformDetection.isNative);
    
    // On mobile platforms, skip the guard
    // Authentication is handled by MobileOAuth2Service in AppComponent.ngOnInit()
    if (this.platformDetection.isNative) {
      console.log('Native platform - skipping MsalGuard, allowing navigation');
      return true;
    }

    // On web, use MsalGuard
    console.log('Web platform - using MsalGuard');
    return this.msalGuard.canActivate(route, state);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(route, state);
  }
}

